import styled from 'styled-components';

export const Contact = styled.section`
  text-align: center;

  div:first-of-type {
    @media only screen and (max-width: 575px) {
      text-align: left;
    }
  }
`;
